import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";

// TODO: Rebranding: This component should be removed when the rebranding is done, replaced by a simple div
export const Container = (props: { children: JSX.Element | JSX.Element[] }): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    if (jnjFullBranded) {
        return <div>{props.children}</div>;
    } else {
        return <>{props.children}</>;
    }
};
